var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnepercent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 81,
    viewBox: "0 0 88 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9876 47.287L50.6451 18.8033C57.5514 22.8377 62.7575 29.243 65.2951 36.8281C67.8327 44.4131 67.5291 52.6617 64.4408 60.0397C61.3526 67.4178 55.6898 73.4231 48.5056 76.9388C41.3214 80.4546 33.1049 81.2415 25.384 79.1532C17.6632 77.065 10.9635 72.2436 6.53099 65.5858C2.09849 58.9281 0.234851 50.8871 1.28667 42.9582C2.33849 35.0294 6.23416 27.7524 12.2492 22.4806C18.2643 17.2088 25.9893 14.3009 33.9876 14.2979",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9876 47.287L50.6451 18.8033C57.5514 22.8377 62.7575 29.243 65.2951 36.8281C67.8327 44.4131 67.5291 52.6617 64.4408 60.0398C61.3526 67.4178 55.6898 73.4231 48.5056 76.9388C41.3214 80.4546 33.1049 81.2415 25.384 79.1532C17.6632 77.065 10.9635 72.2436 6.53099 65.5858C2.09849 58.9281 0.234851 50.8871 1.28667 42.9582C2.33849 35.0294 6.23416 27.7524 12.2492 22.4806C18.2643 17.2088 25.9893 14.3009 33.9876 14.2979",
    stroke: "current",
    strokeWidth: 0.468085,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 1.32863V31.4255L53.9149 5.11443C53.9149 5.11443 47.8595 -0.377419 38 1.32863Z",
    fill: "#202020",
    stroke: "#202020",
    strokeWidth: 0.468085,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnepercent);
export default __webpack_public_path__ + "static/media/onepercent.d404a1723dc69387bdae33836bce80b1.svg";
export { ForwardRef as ReactComponent };